import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <main className="hero">
      {/* Eyebrow */}
      <div className="eyebrow">
        <div className="eyebrow-line"></div>
        <span className="eyebrow-text">Coming to Hyderabad</span>
        <div className="eyebrow-line"></div>
      </div>

      {/* Headline */}
      <h1 className="hero-headline">
        Luxury <em>Living</em><br />
        Redefined
      </h1>

      {/* Subheading */}
      <p className="hero-sub">
        Discover the pinnacle of architectural excellence and timeless elegance. 
        Swayam Homes brings you a new dimension of premium residential spaces.
      </p>
    </main>
  );
};

export default Hero;
